class FacetLoader
  constructor: (allFacets, searchFacets, minimumDeals)->
    @allFacets = allFacets
    @searchFacets = searchFacets
    @loadedFacets = []
    @seekFacets = {}
    @facetLevelTypes = []
    @minDeals = minimumDeals or 3
    @facetToFilter = # this will map GAPI facets to RAPI counterparts
      category2: 'subcategory'
      category3: 'subcategory2'

    @facetSort = (a, b) ->
      a.order - b.order

    @loadFacets = (facets, level) ->
      for facet in facets
        if @seekFacets[facet.id] and facet.count > @minDeals
          levelType = @facetLevelTypes[level]
          @loadedFacets.push
            category: facet.id
            id: facet.id
            count: facet.count
            order: @seekFacets[facet.id]
            name: facet.friendlyNameShort or facet.friendlyName
            level: level
            type: levelType
            query: levelType + ':' + facet.id
        if facet.children and facet.children.length
          @loadFacets facet.children, level+1

    @processFacetConfig = () ->
      if @allFacets and @allFacets.length and @searchFacets
        facets = @allFacets
        searchForFacets = @searchFacets.split(',')
        order = 1
        for facet in searchForFacets
          @seekFacets[facet] = order++
        for facet in facets
          @facetLevelTypes = facet.id.split('|')
          for type, ind in @facetLevelTypes
            @facetLevelTypes[ind] = @facetToFilter[type] ? type
          facetLevel = 0
          @loadFacets(facet.values, facetLevel)
        @loadedFacets.sort(@facetSort)

    @getCategories = () ->
      {foundCats: @loadedFacets}

    if searchFacets
      @processFacetConfig()

module.exports = FacetLoader
